import React, { useEffect, useRef, useState } from "react";
import "./SignupForm.css"; // import CSS file
import login from "../../assets/logo.png"
import { useNavigate } from "react-router-dom";
import CustomInput from "../CustomInput/CustomInput";
import SignaturePad from "react-signature-canvas";
import { PDFDocument, rgb } from "pdf-lib";
import enLang from "../../assets/lang.svg"
import arLang from "../../assets/arlang.png"
import { useDispatch, useSelector } from "react-redux";
import CustomBtn from "../CustomBtn/CustomBtn";
import Select from 'react-select';
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import icons for show/hide
import axios from "axios";
import { Button, Form, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { changeLocal } from "../../hooks/Localization";
import * as pdfjsLib from "pdfjs-dist/webpack";

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import myPdf from "../../assets/file.pdf";
import { loginMethod } from "../../hooks/auth";
import Test from "../../pages/Test";
import CustomPDFModal from "../CustomPDFModal/CustomPDFModal";

// حل مشكلة الـ worker
pdfjs.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


function SignupForm() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [loading, setLoading] = useState(false);
  const [type_id, setType_id] = useState("");
  const [grade_id, setGrade_id] = useState("");
  const inputRef = useRef(null);
    const [signedFile, setSignedFile] = useState(null);
  
    const testRef = useRef();


  const [gender, setGender] = useState("");
  const sigPadRef = useRef(null);
  const [pageIndex, setPageIndex] = useState(0); // 0-based page index to put signature on
  const [x, setX] = useState(400); // x coordinate (points)
  const [y, setY] = useState(85); // y coordinate
  const [width, setWidth] = useState(150); // signature width in PDF points
  const [height, setHeight] = useState(50); // signature height in PDF points
  const [signedBy, setSignedBy] = useState("user@example.com");
  const clearPad = () => sigPadRef.current && sigPadRef.current.clear();

  const downloadSignedPdf = () => {
    if (!signedPdfBytes) return;
    const blob = new Blob([signedPdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = (pdfFile?.name?.replace(/\.pdf$/i, "") || "signed") + "-signed.pdf";
    a.click();
    URL.revokeObjectURL(url);
  };

  const [pdfFile, setPdfFile] = useState(null);         // File object of original PDF
  const [signedPdfBytes, setSignedPdfBytes] = useState(null); // Uint8Array after signing

  const [school_id, setSchool_id] = useState("");
  const [modalState, setModalState] = useState("");
  const [show, setShow] = useState(false);
  const userinfo = useSelector((state) => state);
  const handleClose = () => setShow(false);
  const getSignatureDataUrl = () => {
    if (!sigPadRef.current) return null;
    if (sigPadRef.current.isEmpty()) return null;
    return sigPadRef.current.toDataURL("image/png");
  };
  const embedSignatureAndMark = async () => {
    setStatus("Embedding signature...");
    try {
      if (!pdfFile) throw new Error("Please select a PDF file first.");
      const sigDataUrl = getSignatureDataUrl();
      if (!sigDataUrl) throw new Error("Please draw your signature.");

      // read original PDF bytes
      const arrayBuffer = await pdfFile.arrayBuffer();
      const pdfDoc = await PDFDocument.load(arrayBuffer);

      // embed PNG
      const pngImage = await pdfDoc.embedPng(sigDataUrl);

      // ensure page index in range
      const pages = pdfDoc.getPages();
      const page = pages[pages.length - 1]
      // Draw the signature image on page at x,y with width/height.
      // NOTE: pdf-lib coordinate system: (0,0) is bottom-left.
      page.drawImage(pngImage, {
        x: Number(x),
        y: Number(y),
        width: Number(width),
        height: Number(height),
      });

      // Mark document metadata so we can detect signed PDFs later.
      // We'll set keywords or producer to include "signed:true" and who signed.
      // This isn't cryptographic — attacker could edit metadata — but it's practical.
      const keywords = [`signed:true`, `signedBy:${signedBy}`, `signedAt:${new Date().toISOString()}`];
      pdfDoc.setKeywords(keywords);
      // also set producer to reliably store a short flag
      pdfDoc.setProducer(`SignedBy:${signedBy};signed:true`);

      const modifiedBytes = await pdfDoc.save();
      setSignedPdfBytes(modifiedBytes);
      setStatus("Signature embedded — ready to send.");
    } catch (err) {
      setStatus("Error: " + (err.message || String(err)));
    }
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    parentPhone: "",
    address: "",
    parent_email: "",
    grade: "",
    password: "",
    confirmPassword: "",
    acceptTerms: false,

  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [options, setOptions] = useState(false);
  const [errors, setErrors] = useState({});
  const [gradoptions, setgradoptions] = useState([]);
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("");
    const [pdfText, setPdfText] = useState("");
  const handleShow = async () => {
    setShow(true);

    const url = "/file.pdf";  

    const loadingTask = pdfjsLib.getDocument(url);
    const pdf = await loadingTask.promise;

    let textContent = "";

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const text = await page.getTextContent();
      const pageText = text.items.map((item) => item.str).join(" ");
      textContent += pageText + "\n\n";
    }

    setPdfText(textContent);
  };

  const dispatch = useDispatch();
    const handleLang = (lang) => {
    dispatch(
      changeLocal(lang)
    );
  }
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const onFileChange = (e) => {
    setFile(e.target.files[0] || null);
    setSignedPdfBytes(null);
    setStatus("");
  };
  useEffect(() => {
    const getData = async () => {

      try {
        const response = await axios.get(`https://nanosoft.space/taarteb/public/api/students/schools/4/grade-categories`);

        const optionsRes = response.data.data.map(item => ({
          value: item.id,
          label: item.name
        }));

        setOptions(optionsRes);



      } catch (error) {
        setLoading(false)

      } finally {
        setLoading(false);
      }
      if (grade_id?.value) {
        try {
          const response = await axios.get(`https://nanosoft.space/taarteb/public/api/students/grade-categories/${grade_id?.value}/grades`);
          const optionsRes = response.data.data.map(item => ({
            value: item.id,
            label: item.name
          }));

          setgradoptions(optionsRes);



        } catch (error) {
          setLoading(false)

        } finally {
          setLoading(false);
        }
      }

    }
    getData()
  }, [school_id?.value, grade_id?.value])
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataa = new FormData();
    setLoading(true)


    formDataa.append("name", formData?.name);
    formDataa.append("email", formData?.email);
    formDataa.append("phone", formData?.phone);
    formDataa.append("address", formData?.address);
    formDataa.append("gender", gender?.value);
    formDataa.append("parent_phone", formData?.parent_phone);
    formDataa.append("school_id", 4);
    formDataa.append("grade_id", type_id?.value);
    formDataa.append("password", formData?.password);
    formDataa.append("password_confirmation", formData?.confirmPassword);
    formDataa.append("application_form", signedFile);



    try {
      await axios
        .post(`https://nanosoft.space/taarteb/public/api/students/register`, formDataa, {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
            headers: { "Content-Type": "multipart/form-data" },

          }
        })
        .then(async (res) => {

          dispatch(loginMethod(res.data.data));

          navigate("/payment");
          setLoading(false)


        })
        .catch((error) => {

          setLoading(false)

          toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });


        });

    } catch (error) {
      // if(Object.values(error.response.data.errors)[0][0].includes('Email')){
      //     toast.error(currentLocal.language === "English" ? Object.values(error.response.data.errors)[0][0]:"البريد الالكتروني غير صحيح", { position: "top-right", autoClose: 3000 });

      // }else{
      //     toast.error(currentLocal.language === "English" ?"The selected password is invalid.":"كلمة المرورو غير صحيحة", { position: "top-right", autoClose: 3000 });

      // }
      toast.error(currentLocal.language === "English" ? Object.values(error.response.data.errors)[0][0] : "البريد الالكتروني غير صحيح", { position: "top-right", autoClose: 3000 });
    } finally {
      setLoading(false);

    }
    // localStorage.setItem(name);


    // navigate("/dashboard/dashboard")
  };
  // const options = [
  //   { label: "الابتدائي", value: 'first' },
  //   { label: "الاعدادي", value: 'second' },
  //   { label: "الثانوي", value: 'third' },
  // ];
  
  const [numPages, setNumPages] = useState(null);
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const genderoptions = [
    { label: "ذكر", value: 'm' },
    { label: "أنثي", value: 'f' },
  ];
  // const gradoptions = [
  //   { label: "الصف الاول", value: 'first' },
  //   { label: "الصف الثاني", value: 'second' },
  //   { label: "الصف الثالث", value: 'third' },
  // ];
  const sendSignedPdf = async () => {
    try {
      if (!signedPdfBytes) throw new Error("You must embed signature first.");

      const check = await checkIsSigned(signedPdfBytes);
      if (!check.signed) {
        setStatus("Check failed: PDF does not appear signed. Aborting send.");
        return;
      }

      setStatus("Sending signed PDF...");
      // Create a blob and append to FormData
      const blob = new Blob([signedPdfBytes], { type: "application/pdf" });
      const formData = new FormData();
      formData.append("file", blob, (pdfFile && pdfFile.name?.replace(/\.pdf$/i, '') || 'signed') + "-signed.pdf");
      formData.append("signedBy", signedBy);

      // change URL to your endpoint
      const uploadUrl = "https://your-server.example.com/upload";
      // const resp = await axios.post(uploadUrl, formData, {
      //   headers: { "Content-Type": "multipart/form-data" },
      // });

      // setStatus("Sent successfully: " + (resp.data?.message || "ok"));

      try {

      } catch (error) {
        console.log(error);

      }


    } catch (err) {
      setStatus("Send error: " + (err.response?.data?.message || err.message || String(err)));
    }
  };
  const checkIsSigned = async (fileOrBytes) => {
    try {
      let arrayBuffer;
      if (fileOrBytes instanceof Uint8Array || fileOrBytes instanceof ArrayBuffer) {
        arrayBuffer = fileOrBytes;
      } else if (fileOrBytes instanceof File) {
        arrayBuffer = await fileOrBytes.arrayBuffer();
      } else {
        throw new Error("Unsupported input for checkIsSigned");
      }
      const pdfDoc = await PDFDocument.load(arrayBuffer);
      // metadata checks
      const keywords = pdfDoc.getKeywords(); // may be undefined
      const producer = pdfDoc.getProducer();
      const keywordsStr = Array.isArray(keywords) ? keywords.join(" ") : String(keywords || "");
      const isSignedFromKeywords = keywordsStr.includes("signed:true");
      const isSignedFromProducer = typeof producer === "string" && producer.includes("signed:true");
      return { signed: isSignedFromKeywords || isSignedFromProducer, keywords, producer };
    } catch (err) {
      return { signed: false, error: err.message || String(err) };
    }
  };
  
  const handleOption = (value) => {
    setModalState(value);
    setShow(true)

    // if(value==="signatureOnline"){
    // handleShow()

    // }else{
    // setShow(true)

    // }
  };
  const handleData = (childData) => {
    
setFile(childData)
  };
    const handleSignedPdf = (file) => {
    setSignedFile(file);
  }
  return (
    <div className="signup-container mb-5 pb-5">
      <ToastContainer />
            <CustomPDFModal
        show={show}
        onHide={() => setShow(false)}
        modalState={modalState}
        onSigned={handleSignedPdf}

      />

  
      <div className="text-center">
        <img src={login} alt="" className="w-50" />
      </div>
      <div className="mb-4 d-flex justify-content-center ">
        <div
          onClick={() => handleLang("en")}
          className={currentLocal.language === "English" ? "mx-3 border px-2 py-2 rounded border-dark" : "mx-3  px-2 py-2  "}
          style={{ cursor: "pointer" }}

        >
          <img src={enLang} alt="" className="w-25 me-2" />

          {currentLocal && currentLocal.language === "English" ? "English" : "الانجليزية"}

        </div>
        <div
          onClick={() => handleLang("ar")}
          className={currentLocal.language === "العربيه" ? "mx-3 border px-2 py-2 rounded border-dark" : "mx-3  px-2 py-2  "}
          style={{ cursor: "pointer" }}


        >
          <img src={arLang} alt="" className="w-25 me-2" />

          {currentLocal && currentLocal.language === "العربيه" ? "العربية" : "Arabic"}

        </div>
        {/* <div className="dropdown-item  d-flex align-items-center"
                                    onClick={handleLang}
                                >
                                    <img src={enLang} alt="" className="w-25 me-2" />

                                    {currentLocal&&currentLocal.language === "English" ? currentLocal.home.language : currentLocal.home.switchTo 
                    }
                                    

                                </div> */}
      </div>
      <form onSubmit={handleSubmit} className="signup-form mx-2">
        <div className="form-group">
          <div className="form_container_cart">
            <CustomInput
              placeholder={currentLocal.home.namePlaceholder}
              value={formData.name}
              name="name"
              onChange={handleChange}
            // inputState={emailError}


            />
          </div>
          <span className="error">{errors.name}</span>
        </div>

        <div className="form-group">
          <CustomInput
            placeholder={currentLocal.home.email}
            value={formData.email}
            onChange={handleChange}
            name={"email"}
          // inputState={emailError}

          />
        </div>

        <div className="form-group">
          <CustomInput
            placeholder={currentLocal.home.phone}
            value={formData.phone}
            onChange={handleChange}
            name={"phone"}
          // inputState={emailError}

          />          </div>

        <div className="form-group">
          <CustomInput
            placeholder={currentLocal.home.address}
            value={formData.address}
            name={"address"}
            onChange={handleChange}
          // inputState={emailError}

          />
        </div>
        <div className="form-group">
          <Select
            value={gender}
            onChange={(selectedOption) => setGender(selectedOption)}
            options={genderoptions}
            placeholder={currentLocal.home.gender} // Change this text

          />
        </div>

        <div className="form-group">
          <CustomInput
            placeholder={currentLocal.home.ParentPhone}
            value={formData.parentPhone}
            onChange={handleChange}
            name={"parentPhone"}
          // inputState={emailError}

          />
        </div>

        <div className="form-group">
          <Select
            value={grade_id}
            onChange={(selectedOption) => setGrade_id(selectedOption)}
            options={options}
            placeholder={currentLocal.home.stageName} // Change this text

          />
        </div>

        <div className="form-group">
          <Select
            value={type_id}
            onChange={(selectedOption) => setType_id(selectedOption)}
            options={gradoptions}
            placeholder={currentLocal.home.grade} // Change this text

          />
        </div>

        <div className="form_container_cart position-relative">
          <CustomInput
            type={showPassword ? "text" : "password"} // Toggle input type
            placeholder={currentLocal.home.passwordPlaceholder}
            value={formData.password}
            name={"password"}
            onChange={handleChange}

          />

          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: currentLocal.language === "English" && "10px",
              left: currentLocal.language === "العربيه" && "10px",

              top: "35%",
              transform: "translateY(-50%)",
              cursor: "pointer"
            }}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <div className="form_container_cart position-relative">
          <CustomInput
            type={showConfirmPassword ? "text" : "password"} // Toggle input type
            placeholder={currentLocal.home.passwordPlaceholder}
            value={formData.confirmPassword}
            name={"confirmPassword"}

            onChange={handleChange}

          />

          <span
            className="eye-icon"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            style={{
              position: "absolute",
              right: currentLocal.language === "English" && "10px",
              left: currentLocal.language === "العربيه" && "10px",

              top: "35%",
              transform: "translateY(-50%)",
              cursor: "pointer"
            }}
          >
            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <div
          className="form-group checkbox-group"

        >
          <label
            style={{ cursor: "pointer" }}

          >
            {currentLocal.home.Registrationfile} {signedFile&&"("+currentLocal.home.RegistrationfileDone+")"}
          </label>
        </div>
        <div className="d-flex align-items-center">

          <Form dir={currentLocal.language === "العربية" && "rtl"}>
            {['radio'].map((type) => (
              <div key={`inline-${type}`} className="mb-3">
                <Form.Check
                  inline
                  reverse={currentLocal.language === "العربيه"}
                  label={<span style={{ cursor: "pointer" }}>{currentLocal.home.signAndResend}</span>}
                  name="group1"
                  type={type}
                  id={`inline-${type}-1`}
                  style={{ cursor: "pointer" }}
                  onChange={() => handleOption("signAndResend")}

                />
                <Form.Check
                  inline
                  reverse={currentLocal.language === "العربيه"}
                  label={<span style={{ cursor: "pointer" }}>{currentLocal.home.signatureOnline}</span>}
                  name="group1"
                  type={type}
                  id={`inline-${type}-2`}
                  style={{ cursor: "pointer" }}
                  onChange={() => handleOption("signatureOnline")}


                />
              </div>
            ))}
          </Form>


        </div>
        <div>
        </div>
        <span className="error">{errors.acceptTerms}</span>
        <div className="text-center w-100">
          <CustomBtn text={loading ? currentLocal.home.Loading : currentLocal.home.login} disabled={loading} type={"submit"} />

        </div>
      </form>
    </div>
  );
}

export default SignupForm;


